import React, { useEffect, useState, useCallback } from 'react';
import { Box, TextField, Autocomplete, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, FormControl, InputLabel, Select, MenuItem, Grid, FormHelperText, Menu } from '@mui/material';
import { Colors } from '../../../../../Styles/Colors';
import { CommonPatientCard, CommonPatientDetails } from '../../../../../Components/Common Components/CommonComponents';
import { getCachevalue, localGetItem, setCachevalue } from '../../../../../Utility/Services/CacheProviderService';
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../../Components/Loader';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { formatDateAndTimeMeth2, CheckAccessFunc, AmountFormat } from '../../../../../Components/CommonFunctions/CommonFunctions';
import { useHistory } from 'react-router-dom';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs from 'dayjs';
import CommonValidation from '../../../../../Components/CommonFunctions/CommonValidation';
import { CurrencySymbol } from '../../../../../Utility/Constants';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LineItemRemarksButton from '../../../../../Components/Common Components/LineItemRemarksButton';
import { isLineItemRemarksEnabled, clampLineItemRemarks } from '../../../../../Utility/lineItemRemarksUtils';

const OrderListScreen = ({opOrder, ...props}) => {
    const history = useHistory();
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const AmountViewAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.show_order_amounts) || (loggedInUserInfo?.is_doctor))
    const AmountEditAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.edit_order_amounts) || (loggedInUserInfo?.is_doctor))
    const ConcessionAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.allow_concession) || (loggedInUserInfo?.is_doctor))
    const showPaymentStatusColumn = loggedInUserInfo?.permission_access?.common?.restrict_payment_status !== true
    const [view, setView] = useState('list');
    const [filters, setFilters] = useState({ module: 'All', status: 'Pending,Billed,Accepted', service_head: null, service_name: null });
    const [formState, setformState] = useState({
        PatientData: {},
        ListData: [],
        SummaryData: [],
        cancel_reason: '',
        isEdit: false,
        openDeletePopup: false,
        deleted_service: null,
        selected_cancel_service: null,
        deletedType: '',
        selectedIndex: '',
        selectedUnitIndex: '',
        selectedData: '',
        openDialog: false,
        is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
        wardList: [],
        selectedward: null,
        billDocSugg: [],
        selected_bill_doc: null,
        selected_service: null,
        service_data: {
            rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
            doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
            hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
            interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
            service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
            edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
            end_time: '', doc_discount_amt: '', doc_discount_percent: '',
            hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
            concession_percent: '', gst_percent: 0, hours: '', minutes: '',
            concession_comments: '', service_details_id: '', doctor_id: '',
            review_days: '', review_count: '', charge_id: '',
            gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
            taxable_amount: '', sub_total_amount: '', round_off: '',
            received_amount: '', net_amount: '', concession_percent_w_r: '',
            doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
            doctor_percent_w_r: '', hospital_percent_w_r: '',
            module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
            service_head_id: null, doctor_id: '', op_order_number: '',
            id: null
        },
    });
    const [selectedRadio, setSelectedRadio] = useState('input')
    const [popupValues, setPopupValues] = useState({})
    const [openPopup, setOpenPopup] = useState(false)
    const [isLoader, setIsLoader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [state, setState] = useState({
        menuAnchorEl: null,
        menuRowId: null,
        isIssueDrug: false,
    })
    const [amtState, setamtState] = useState([])
    const [InvestigationList, setInvestigationList] = useState([])
    const [insuToolOpen, setInsuToolOpen] = useState(false); 
    

    const COMMON_STYLES = {
        HEIGHT: '4.5dvh',
        FONT_SIZE_XS: '0.7rem',
        FONT_SIZE_SM: '0.8rem',
        FONT_SIZE_MD: '0.85rem',
        FONT_SIZE_L: '0.9rem',
        FONT_WEIGHT: 600
    }

    const RoomChargeGST = JSON.parse(localGetItem('gst_room_charge'))

    useEffect(() => {
        let PatientData = opOrder ? getCachevalue("patientData") : getCachevalue("IppatientData");
        if (PatientData) {
            setformState((prev) => ({
                ...prev,
                PatientData: JSON.parse(PatientData)
            }));
            getDoctorList();
            if (props?.FromIp) {
                getWardList();
            }
        }

        // Hide tooltip after 2 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(false);
        }, 2000);

        setInvestigationList(localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : [])

        return () => {
            clearTimeout(hideTooltip);
        };   
    }, []);

    useEffect(() => {
        if (formState.PatientData?.appointment_id || formState.PatientData?.id) {
            getOrderListData();
            getOrderCardAmt();
        }
    }, [view, (formState.PatientData?.appointment_id || formState.PatientData?.id), filters?.module, filters?.status]);

    const getOrderListData = () => {
        try {
            if (!formState.PatientData?.appointment_id && !formState.PatientData?.id) return;

            const isAppointment = !!formState.PatientData?.appointment_id;
            const apiUrl = isAppointment ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_ORDER_LIST_IP;
            const queryParam = isAppointment ? `appointment_id=${formState.PatientData?.appointment_id}` : `ip_admission_id=${formState.PatientData?.id}`;
            setIsLoader(true)
            RestAPIService.getAll(`${apiUrl}?${queryParam}&get_type=${view}&order_status=${[filters?.status]}&module_type=${filters?.module === 'All' ? '' : filters?.module}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const orderListData = response.data.data || [];
                        setIsLoader(false)
                        if (view === "list") {
                            setformState((prevState) => ({
                                ...prevState,
                                ListData: orderListData,
                            }));
                        } else {
                            setformState((prevState) => ({
                                ...prevState,
                                SummaryData: orderListData,
                            }));
                        }
                    }
                }).catch((error) => {
                    setIsLoader(false)
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false)
            errorMessage(error.message)
        }
    }

    const getOrderCardAmt = () => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_BILLING_ORDER_DEPTWISE + `?order_type=${opOrder ? "op" : "ip"}&${opOrder ? `appointment_id=${formState?.PatientData?.appointment_id}` : `admission_id=${formState?.PatientData?.id}`}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const AmtValues = Object.entries(response?.data?.data)?.map(([key, value]) => ({
                            module: key,
                            amount: value
                        }));
                        setamtState(AmtValues)
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handleUpdateOrder = (row) => {
        try {
            const updatedItem = [{
                id: row?.id,
                unit: row?.unit,
                rate_per_unit: +row?.rate_per_unit || 0,
                total_amount: +row?.total_with_discount || +row?.total_amount || 0,
                sub_total_amount: +row?.sub_total_amount || 0,
                doctor_share_percent: +row.doctor_percent || +row.doctor_share_percent || 0,
                hospital_share_percent: +row.hospital_percent || +row.hospital_share_percent || 0,
                old_doctor_fee: +row.old_doctor_amt || +row.old_doctor_fee || 0,
                old_hospital_fee: +row.old_hospital_amt || +row.old_hospital_fee || 0,
                new_doctor_fee: +row.new_doctor_amt || +row.new_doctor_fee || 0,
                new_hospital_fee: +row.new_hospital_amt || +row.new_hospital_fee || 0,
                discount_amount: +row?.concession_amt || +row?.discount_amount || 0,
                discount_percentage: +row?.concession_percent || +row?.discount_percentage || 0,
                start_time: row.start_date ? dayjs(row.start_date).format("YYYY-MM-DD HH:mm:ss") : null,
                end_time: row.end_date ? dayjs(row.end_date).format("YYYY-MM-DD HH:mm:ss") : null,
                service_old_unit_count: row?.unit_type === 'Hrs' ? row?.old_time_taken : null,
                remarks: clampLineItemRemarks(
                    row?.line_item_remarks != null ? String(row.line_item_remarks) : (row?.remarks != null ? String(row.remarks) : '')
                ),
            }];
            setIsLoader(true);
            const apiUrl = formState?.PatientData?.appointment_id ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_ORDER_LIST_IP;
            RestAPIService.create(updatedItem, apiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setIsLoader(false);
                        clearSelection()
                        successMessage(response.data.message);
                        getOrderListData();
                        getOrderCardAmt()
                    }
                }).catch(e => {
                    setIsLoader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                });
        } catch (e) {
            setIsLoader(false);
            errorMessage(e.message);
        }
    }

    const deleteOrderList = () => {
        try {
            let data = {
                remarks: formState.cancel_reason,
                ...(formState?.deletedType === 'list' ? { line_item_id: formState?.deleted_service } : { order_id: formState?.deleted_service })
            };
            setIsLoader(true)
            const apiUrl = formState?.PatientData?.appointment_id ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_ORDER_LIST_IP;
            RestAPIService.delete(`${apiUrl}`, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setIsLoader(false)
                        setformState((prev) => ({ ...prev, openDeletePopup: false, deleted_service: null, selected_cancel_service : null, deletedType: '', cancel_reason: '' }))
                        getOrderListData()
                        getOrderCardAmt()
                    }
                }).catch(e => {
                    setIsLoader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setIsLoader(false)
            errorMessage(e.message)
        }
    }

    const confirmationPopup = () => {
        return (
            <Dialog open={formState?.openDialog} onClose={() => {
                setformState((prev) => ({
                    ...prev,
                    selectedIndex: '',
                    selectedData: '', openDialog: false
                }))
            }}>
                <DialogTitle>Confirm Change</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to update the service ?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button size='small' onClick={() => {
                        setformState((prev) => {
                            return {
                                ...prev, 
                                openDialog: false
                            };
                        });
                    }} variant='outlined' sx={{ textTransform: 'capitalize' }}>
                        Cancel
                    </Button>
                    <Button size='small' onClick={() => {
                        let { service_data, selected_bill_doc, selectedward } = formState || {};
                        let { unit_type, total_amount = 0, gst_percent = 0, unit = 0, rate_per_unit = 0 } = service_data || {};
                        let discountTotal = (+formState.service_data.total_amt) - (+formState.service_data.concession_amt)
                        let incGst = loggedInUserInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, formState.service_data.gst_percent) : 0
                        let tltGstdiff = loggedInUserInfo?.is_gst_enabled ? incGst - discountTotal : 0
                        let sgstCgst = loggedInUserInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0
                        let service_list = {
                            ...service_data,
                            total_with_discount: discountTotal,
                            service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                            gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                            sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                            cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                            igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                            taxable_amount: discountTotal,
                            sub_total_amount: formState.service_data.total_amt,
                            concession_applicable: formState?.service_data?.edit_discount ? (formState?.service_data?.is_hospital ? formState?.service_data?.new_hospital_amt : discountTotal) : 0,
                            module_type: formState.service_data.module_type,
                            unit: formState.service_data?.unit,
                            service_head_id: formState.service_data?.service_head_id,
                            doctor_id: formState.selected_bill_doc?.doctor_id || formState.selected_bill_doc_id,
                            doctor_name: formState.selected_bill_doc?.doctor_name || formState.selected_bill_doc,
                            id: formState.service_data?.id ? formState?.service_data?.id : null,
                            package_detail_id: formState.service_data?.package_detail_id ? formState?.service_data?.package_detail_id : null,
                            package_name: formState?.service_data?.package_name ? formState?.service_data?.package_name : '',
                        };
                        handleUpdateOrder(service_list)
                    }} color="primary" variant="contained" sx={{ textTransform : 'capitalize'}}>
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const getWardList = () => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.WARD_CONFIG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        let selectedWard = response?.data?.data?.find(ward => ward?.id === formState.PatientData?.ward_id);
                        setformState((prev) => ({ ...prev, wardList: response?.data?.data, selectedward: selectedWard }))
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getDoctorList = () => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const doctors = response?.data?.data || [];
                        setformState((prev) => ({ ...prev, billDocSugg: doctors }));
                        setInsuToolOpen(true);
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    setInsuToolOpen(true);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            setInsuToolOpen(true);
            errorMessage(error.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
    };

    const renderDeletePopup = () => {
        try {
            return (
                <Dialog open={formState.openDeletePopup} maxWidth='sm' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'1px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600} color={'#bb3c3c'}>Cancellation Remarks</Typography>
                            <IconButton onClick={() => setformState((prev) => ({ ...prev, openDeletePopup: false, deleted_service: null, selected_cancel_service : null, deletedType: '', cancel_reason: '' }))}>
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p='0.5rem'>
                            <Box component={'div'} mt={'1rem'}>
                                <TextField
                                    multiline
                                    size='small'
                                    fullWidth
                                    rows={4}
                                    inputProps={{ maxLength: 250 }}
                                    value={formState.cancel_reason}
                                    label='Comments Here *'
                                    onChange={(e) => {
                                        setformState((prev) => ({ ...prev, cancel_reason: e.target.value }))
                                    }}
                                />
                                {(formState.selected_cancel_service?.is_advance_adjusted || formState.selected_cancel_service?.advance_adjusted_amount) ? <Typography sx={{ color: "red", margin:"0.3vw", fontSize:"0.9vw"}}>{`The adjusted advance amount of ${AmountFormat(formState.selected_cancel_service?.advance_adjusted_amount || formState.selected_cancel_service?.total_amount)} will be added back to the advance.`}</Typography> : null}
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mb={'0.5rem'}>
                            <Button variant='outlined'
                                color='error'
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                onClick={() => setformState((prev) => ({ ...prev, openDeletePopup: false, deleted_service: null, selected_cancel_service : null, deletedType: '', cancel_reason: '' }))}
                            >Close</Button>
                            <Button variant='contained'
                                color='error'
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                onClick={() => {
                                    if (!formState.cancel_reason.trim()) {
                                        errorMessage('Enter Cancellation Remarks');
                                        return;
                                    }
                                    deleteOrderList();
                                }}
                            >Cancel</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const CommonPatientSection = ({ PatientData }) => {
        let attender = {
            lineOne: "AttenderName",
            lineTwo: PatientData?.attender_name || "-",
            lineFour: "ContactNumber",
            lineFive: PatientData?.attender_mobile || "-",
        };

        const createOrderAmtCard = (label, amount) => ({
            image: ImagePaths.OrderIcon.default,
            height: "1.3vw",
            width: "1.3vw",
            lineOne: label,
            lineTwo: amount ? AmountFormat(amount) : `${CurrencySymbol} 0.00`,
        });

        return (
            <Box display={'flex'} alignItems='center'>
                <Box className="eMed_Patient_Details_Long eMed_patient_box">
                    <CommonPatientDetails data={PatientData} showDetailed={true} forceOpen = {insuToolOpen}/>
                </Box>
                {formState.PatientData?.appointment_id ? null : <CommonPatientCard details={attender} showDetailed={true} />}
                {showPaymentStatusColumn ? <Box sx={{ display: 'flex', width: opOrder ? "56dvw" : "43.7dvw", alignItems: 'center', overflow: 'auto' }}>
                    {
                        amtState?.map((item, index) => (
                            <CommonPatientCard key={index} details={createOrderAmtCard((item?.module), item?.amount)} smallWidth={true} />
                        ))
                    }
                </Box> : null}
            </Box>
        );
    };

    const popupTextBox = (key, values, multiline, row, labels, readOnly, width) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    size='small'
                    sx={{ width: width || '13dvw' }}
                    value={values}
                    onChange={(e) => onPopupChangeHandler(e, key)}
                    multiline={multiline}
                    rows={row}
                    label={labels}
                    InputProps={{ readOnly: readOnly, emed_tid: key }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onSavePopupHandler = (type) => {
        try {
            setformState((prev) => {
                let updates = { ...prev.service_data };

                switch (type) {
                    case 'rate':
                        let total = 0;
                        if (popupValues.unit_type === 'Nos') {
                            total = popupValues.rate_per_unit * popupValues.unit
                        } else {
                            let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                            let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)
                            total = hourTotal
                        }
                        let concession = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(total)
                        updates.rate_per_unit = +CommonValidation.formatAmount(popupValues.rate_per_unit)
                        updates.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, popupValues.old_doctor_amt)
                        updates.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, popupValues.old_hospital_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concession)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concession, total)
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concession, total)
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'concession':
                        let concessionAmt = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.new_doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.new_hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(popupValues.total_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concessionAmt)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concessionAmt, popupValues.total_amt)
                        updates.doc_discount_amt = +CommonValidation.formatAmount(popupValues.doc_discount_amt)
                        updates.doc_discount_percent = +popupValues.doc_discount_percent
                        updates.hos_discount_amt = +CommonValidation.formatAmount(popupValues.hos_discount_amt)
                        updates.hos_discount_percent = +popupValues.hos_discount_percent
                        updates.concession_comments = popupValues.concession_comments
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concessionAmt, popupValues.total_amt)
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'time':
                        let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                        let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)

                        updates.total_amt = hourTotal
                        updates.unit = Hours.split(":")[0] + ":" + Hours.split(":")[1]
                        updates.old_time_taken = popupValues.old_time_taken
                        updates.interval_amount = popupValues.interval_amount
                        updates.interval_time = popupValues.interval_time
                        updates.rate_per_unit = popupValues.rate_per_unit
                        updates.old_doctor_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal)
                        updates.old_hospital_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal)
                        let docDisc = CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, updates.old_doctor_amt)
                        let hosDis = CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, updates.old_hospital_amt)
                        updates.doc_discount_amt = +docDisc
                        updates.hos_discount_amt = +hosDis
                        updates.new_doctor_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal) || 0) - (+docDisc || 0)
                        updates.new_hospital_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal) || 0) - (+hosDis || 0)
                        updates.concession_amt = updates.doctor_amt && updates.hospital_amt ? (+docDisc) + (+hosDis) : CommonValidation.getDiscountAmountWithRound(popupValues.concession_percent, hourTotal)
                        break;
                }

                return { ...prev, service_data: updates };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const TimePopup = () => {
        let totalAmt = +popupValues.doctor_amt + (+popupValues.hospital_amt)
        const appointmentDate = formState?.PatientData?.appointment_date ? dayjs(formState?.PatientData?.appointment_date) : formState?.PatientData?.admission_date ? dayjs(formState?.PatientData?.admission_date) : dayjs(new Date());
        const currentDate = dayjs();
        const startDate = dayjs(popupValues?.start_date);
        return (
            <>{openPopup === 'rate' ?
                <Dialog open={openPopup === 'rate'} maxWidth='sm' fullWidth>
                    <Box className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Update Rate Per Unit</Typography>
                            <IconButton
                                onClick={() => setOpenPopup(null)}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                            <Box component={'div'} display={'flex'} justifyContent={'space-evenly'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Rate / Unit - ${popupValues?.rate_per_unit ? CommonValidation.formatAmount(popupValues?.rate_per_unit) : '0'}`}</Typography>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Unit - ${popupValues?.unit}`}</Typography>
                            </Box>
                            <Box component={'div'} mt={'1rem'}>
                                <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_amt', popupValues?.doctor_amt, false, 1, `Doctor Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_percent', popupValues?.doctor_percent_w_r, false, 1, 'Doctor Percentage (%)', true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_amt', popupValues?.hospital_amt, false, 1, `Hospital Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_percent', popupValues?.hospital_percent_w_r, false, 1, `Hospital Percentage (%)`, true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Total Amount</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_amt', totalAmt ? CommonValidation.formatAmount(totalAmt) : '', false, 1, `Total Amount (${CurrencySymbol})`, true)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_percent', '100.00', false, 1, `Total Percentage (%)`, true)}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box m={'1rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => setOpenPopup(null)}
                            >Close</Button>
                            <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => {
                                    onSavePopupHandler('rate')
                                    setOpenPopup(null)
                                }}
                            >Save</Button>
                        </Box>
                    </Box>
                </Dialog> :
                openPopup === 'concession' ?
                    <Dialog open={openPopup === 'concession'} maxWidth='sm' fullWidth>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Concession</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600}>{`Bill Amount : ${CommonValidation.formatAmount(popupValues?.total_amt)}`}</Typography>
                                </Box>
                                <Box component={'div'} mt={'1rem'}>
                                    <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_amt', popupValues?.doc_discount_amt, false, 1, `Amount (${CurrencySymbol})`, popupValues?.is_hospital)}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_percent', popupValues?.doc_discount_percent_w_r, false, 1, 'Percentage (%)', popupValues?.is_hospital)}
                                        </Grid>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_amt', popupValues?.hos_discount_amt, false, 1, `Amount (${CurrencySymbol})`)}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_percent', popupValues?.hos_discount_percent_w_r, false, 1, 'Percentage (%)')}
                                        </Grid>
                                    </Grid>
                                </Box>
                                {popupValues?.is_hospital ? <Box><FormHelperText sx={{ color: 'red', fontSize: COMMON_STYLES.FONT_SIZE_SM, textAlign: 'center' }}>Concession Enable Only For Hospital !</FormHelperText></Box> : null}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '0.5rem' }}>
                                    <Box>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Doctor Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_doctor_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.doc_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_doctor_amt) || 0}`}</Typography>
                                    </Box>
                                    <Box mr={'2rem'}>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Hosptial Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_hospital_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.hos_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_hospital_amt) || 0}`}</Typography>
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'}>
                                    {popupTextBox('concession_comments', popupValues?.concession_comments, true, 3, 'Concession Comments', false, '37dvw')}
                                </Box>
                            </Box>
                            <Box m={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => setOpenPopup(null)}
                                >Close</Button>
                                <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => {
                                        onSavePopupHandler('concession')
                                        setOpenPopup(null)
                                    }}
                                >Save</Button>
                            </Box>
                        </Box>
                    </Dialog> :
                    <Dialog open={openPopup === 'time'} maxWidth='sm'>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Unit</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                                    <RadioGroup row
                                        value={selectedRadio}
                                        onChange={(e) => { setSelectedRadio(e.target.value) }}
                                    >
                                        <FormControlLabel value={'input'} control={<Radio size='small' />} label="Based on Input" />
                                        <FormControlLabel value={'time'} control={<Radio size='small' />} label="Based on Time" />
                                    </RadioGroup>
                                </Box>
                                <Box component={'div'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Input</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.hours}
                                            onChange={(e) => { onPopupChangeHandler(e, 'hours') }}
                                            label='Hours'
                                            sx={{ width: '15dvw' }}
                                        />
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.minutes}
                                            onChange={(e) => { onPopupChangeHandler(e, 'minutes') }}
                                            label='Minutes'
                                            sx={{ width: '15dvw', ml: '1rem' }}
                                        />
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Time</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.start_date}
                                                name={"datePicker"}
                                                open={formState.startTimeOpen}
                                                onOpen={() => { setformState((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                onClose={() => { setformState((prev) => ({ ...prev, startTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('Start Date & Time')}
                                                minDateTime={appointmentDate}
                                                maxDateTime={currentDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'startDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setformState((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    size='small' {...params} sx={{ width: '15dvw' }}
                                                />}
                                            />
                                        </LocalizationProvider>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.end_date}
                                                name={"datePicker"}
                                                open={formState.endTimeOpen}
                                                onOpen={() => { setformState((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                onClose={() => { setformState((prev) => ({ ...prev, endTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('End Date & Time')}
                                                minDateTime={startDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'endDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setformState((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    sx={{ ml: '1rem', width: '15dvw' }}
                                                    size='small' {...params}
                                                />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                                        <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                            onClick={() => setOpenPopup(null)}
                                        >Close</Button>
                                        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                            onClick={() => {
                                                onSavePopupHandler('time')
                                                setOpenPopup(null)
                                            }}
                                        >Add</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Dialog>
            }</>
        )
    }

    const onChangeTimeHandler = useCallback((time, key) => {
        try {
            if (!time) return;

            if (key === 'startDate') {
                if (!popupValues?.end_date) {
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time
                    }));
                } else {
                    const timeDiff = getTimeDifference(time, popupValues.end_date);
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time,
                        hours: timeDiff?.split(':')[0],
                        minutes: timeDiff?.split(':')[1],
                    }));
                }
            }

            if (key === 'endDate') {
                if (!popupValues.start_date) {
                    errorMessage('Select Start Date');
                    return;
                }

                const timeDiff = getTimeDifference(popupValues.start_date, time);
                setPopupValues(prev => ({
                    ...prev,
                    end_date: time,
                    hours: timeDiff?.split(':')[0],
                    minutes: timeDiff?.split(':')[1],
                }));
            }
        } catch (error) {
            errorMessage(error.message);
        }
    }, [popupValues]);

    function getTimeDifference(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        start.setSeconds(0, 0);
        end.setSeconds(0, 0);

        let diff = end - start;

        const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
        diff %= (1000 * 60 * 60);

        const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    const InlineSavePopupHandler = (rowIndex = null) => {
        try {

            const updatedOrderList = [...formState.ListData];

            const formattedHours = popupValues?.hours?.toString()?.padStart(2, "0") || "00";
            const formattedMinutes = popupValues?.minutes?.toString()?.padStart(2, "0") || "00";
            const Hours = `${formattedHours}:${formattedMinutes}:00`;

            const ratePerUnit = popupValues?.rate_per_unit || 0;
            const oldTimeTaken = popupValues?.old_time_taken || "00:00";
            const intervalTime = popupValues?.interval_time || "00:00";
            const intervalAmount = popupValues?.interval_amount || 0;

            const hourTotal = CalculateHourAmount(ratePerUnit, Hours, oldTimeTaken, intervalTime, intervalAmount);

            const doctorPercent = updatedOrderList[rowIndex]?.doctor_share_percent || 0;
            const hospitalPercent = updatedOrderList[rowIndex]?.hospital_share_percent || 0;

            const doctorAmount = ((hourTotal * doctorPercent) / 100);
            const hospitalAmount = ((hourTotal * hospitalPercent) / 100);

            updatedOrderList[rowIndex] = {
                ...updatedOrderList[rowIndex],
                total_amount: (hourTotal * (1 + (popupValues?.gst_percent || 0) / 100)),
                sub_total_amount: hourTotal,
                unit: `${formattedHours}:${formattedMinutes}`,
                old_time_taken: oldTimeTaken,
                interval_amount: intervalAmount,
                interval_time: intervalTime,
                rate_per_unit: ratePerUnit,
                start_date: popupValues?.start_date,
                end_date: popupValues?.end_date,
                doctor_amt: doctorAmount,
                hospital_amt: hospitalAmount,
                isEditing: false
            };

            setformState(prev => ({
                ...prev,
                ListData: updatedOrderList
            }));

            handleUpdateOrder(updatedOrderList[rowIndex]);

        } catch (error) {
            errorMessage(error.message);
        }
    };

    const onPopupChangeHandler = (e, key) => {
        try {
            let value = e.target.value;

            setPopupValues((prev) => {
                let updateState = {};

                const pageType = formState?.PatientData?.appointment_id ? 'op' : 'ip';
                const admissionTime = new Date(formState?.PatientData?.admission_date);
                const currentTime = new Date();

                const diffMs = (currentTime - admissionTime) + 3600000;
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                const minHoursForIP = diffHours < 24 ? 24 : diffHours;
                const minMinutesForIP = diffHours < 24 ? 59 : diffMinutes;

                const maxHours = pageType === 'op' ? 24 : minHoursForIP;
                const maxMinutes = pageType === 'op' ? 59 : minMinutesForIP;

                switch (key) {
                    case 'doctor_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.hospital_amt)
                            updateState.doctor_amt = value;
                            updateState.new_doctor_amt = value;
                            updateState.old_doctor_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.hospital_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(value, totalAmt)
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt)
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(+popupValues.hospital_amt, totalAmt)
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.hospital_amt, totalAmt)
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.doc_discount_percent, value)
                        }
                        break;
                    case 'hospital_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.doctor_amt)
                            updateState.hospital_amt = value;
                            updateState.new_hospital_amt = value;
                            updateState.old_hospital_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.doctor_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(value, totalAmt) || 0
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt) || 0
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.hos_discount_percent, value) || 0
                        }
                        break;
                    case 'doctor_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_doctor_amt || value === '') {
                            updateState.doc_discount_amt = value
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                            updateState.doc_discount_percent = +CommonValidation.getDiscountPercentage(value, +popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, +popupValues.old_doctor_amt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                        }
                        break;
                    case 'hospital_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_hospital_amt || value === '') {
                            updateState.hos_discount_amt = value
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                            updateState.hos_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                        }
                        break;
                    case 'doctor_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent = value
                            updateState.doc_discount_percent_w_r = value
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                        }
                        break;
                    case 'hospital_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmount(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent = value
                            updateState.hos_discount_percent_w_r = value
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                        }
                        break;
                    case 'concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.concession_comments = value
                        }
                        break;
                    case 'hours':
                        if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= 24) && pageType === 'op') {
                            updateState.hours = value;
                            if (value === '24') {
                                updateState.minutes = "00";
                            }
                        } else if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= maxHours) && pageType === 'ip') {
                            updateState.hours = value;
                            if (value === maxHours.toString()) {
                                updateState.minutes = "00";
                            }
                        }
                        break;
                    case 'minutes':
                        const hourVal = parseInt(popupValues?.hours || 0);
                        if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= 59 && hourVal < 24 && pageType === 'op')
                        ) {
                            updateState.minutes = value;
                        } else if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= maxMinutes && hourVal < maxHours && pageType === 'ip')
                        ) {
                            updateState.minutes = value;
                        }
                        break;
                }
                return { ...prev, ...updateState };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const convertTimeToDecimal = (time) => {
        try {
            let [hours, minutes] = time?.split(':')?.map(Number);
            return hours * 60 + minutes;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const CalculateHourAmount = (ratePerHour, changedTime, fixedTime, minTime, minAmount) => {
        let fixedTimes = convertTimeToDecimal(fixedTime);
        let changedTimes = convertTimeToDecimal(changedTime);
        let minTimes = convertTimeToDecimal(minTime ? minTime : '00:00');

        let changeAndFixedTime = changedTimes - fixedTimes;
        let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0;

        let timeCalculateTime = (minTimes === 0) ? 0 : Math.ceil(time / minTimes);

        let totalCost = (+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0));

        return totalCost;
    };

    const InlineTimePopup = (data, index) => {
        setOpenPopup(true)
        setformState((prev) => ({ ...prev, selectedUnitIndex: index }))
        setPopupValues((prev) => {
            let popupUpdates = {};

            let hours = data?.unit?.split(":")[0] || ''
            let mins = data?.unit?.split(":")[1] || ''

            popupUpdates.hours = hours
            popupUpdates.minutes = mins
            popupUpdates.start_date = data?.start_time ? dayjs(data?.start_time) : data?.start_date ? dayjs(data?.start_date) : (formState?.PatientData?.appointment_date ? dayjs(formState?.PatientData?.appointment_date) : formState?.PatientData?.admission_date ? dayjs(formState?.PatientData?.admission_date) : dayjs(new Date()))
            popupUpdates.end_date = data?.end_time ? dayjs(data?.end_time) : data?.end_date ? dayjs(data?.end_date) : null;
            popupUpdates.interval_amount = data?.interval_amount
            popupUpdates.interval_time = data?.interval_time
            popupUpdates.old_time_taken = data?.service_unit
            popupUpdates.rate_per_unit = data?.rate_per_unit
            popupUpdates.total_amount = data?.total_amount
            popupUpdates.sub_total_amount = data?.sub_total_amount
            popupUpdates.unit = data?.unit
            popupUpdates.gst_percent = data?.gst_percent

            return {
                ...prev,
                ...popupUpdates
            }
        })
    }

    const EditDisable = (item) => {
        if (formState?.PatientData?.appointment_id) {
            return !item?.edit_unit || item?.order_line_status !== 'Pending' || InvestigationList?.includes(item?.module_type)
        } else {
            return !item?.edit_unit || (item?.order_line_status !== 'Pending' && (['IP', 'IP_OP'].includes(item?.module_type) && item?.is_processed)) || item?.order_line_status === 'Billed' || InvestigationList?.includes(item?.module_type)
        }
    }

    const orderLineRemarksReadOnly = (item) => {
        if (formState?.PatientData?.is_final_bill_initiated) return true
        return (
            EditDisable(item) ||
            item?.package_type === 'Assorted' ||
            item?.package_type === 'Package' ||
            item?.service_head_name === 'Room Charges' ||
            item?.is_advance_adjusted
        )
    }

    const DeleteDisabled = (item) => {
        if (formState?.PatientData?.appointment_id) {
            return item?.order_line_status !== 'Pending';
        } else {
            const isIPProcessed =
                (['IP', 'IP_OP'].includes(item?.module_type) && item?.is_processed) &&
                item?.order_line_status !== 'Pending';

            const isLabOrRadiology =
                (['LAB', 'RADIOLOGY'].includes(item?.module_type) || InvestigationList?.includes(item?.module_type)) && item?.order_line_status !== 'Pending';

            return isIPProcessed || isLabOrRadiology || item?.order_line_status === 'Billed';
        }
    };

    const onOpenPopupHandler = (type) => {
        setOpenPopup(type)
        setPopupValues((prev) => {
            let popupUpdates = {};
            switch (type) {
                case 'rate':
                    popupUpdates.doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.doctor_percent = formState?.service_data?.doctor_percent
                    popupUpdates.doctor_percent_w_r = formState?.service_data?.doctor_percent_w_r
                    popupUpdates.hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.hospital_percent = formState?.service_data?.hospital_percent
                    popupUpdates.hospital_percent_w_r = formState?.service_data?.hospital_percent_w_r
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState.service_data.unit_type === 'Nos' ? formState?.service_data?.total_amt / formState?.service_data?.unit :
                        formState.service_data.rate_per_unit
                    popupUpdates.unit = formState?.service_data?.unit
                    break
                case 'concession':
                    popupUpdates.old_doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.old_hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.new_doctor_amt = formState?.service_data?.new_doctor_amt
                    popupUpdates.new_hospital_amt = formState?.service_data?.new_hospital_amt
                    popupUpdates.doctor_amt = formState?.service_data?.doctor_amt
                    popupUpdates.hospital_amt = formState?.service_data?.hospital_amt
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    break;
                case 'time':
                    let hours = formState?.service_data?.unit?.split(":")[0] || ''
                    let mins = formState?.service_data?.unit?.split(":")[1] || ''

                    popupUpdates.hours = hours
                    popupUpdates.minutes = mins
                    popupUpdates.start_date = formState?.service_data?.start_date
                    popupUpdates.end_date = formState?.service_data?.end_date;
                    popupUpdates.interval_amount = formState?.service_data?.interval_amount
                    popupUpdates.interval_time = formState?.service_data?.interval_time
                    popupUpdates.old_time_taken = formState?.service_data?.fixed_time
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    popupUpdates.total_amount = formState?.service_data?.total_amount
                    popupUpdates.sub_total_amount = formState?.service_data?.sub_total_amount
                    popupUpdates.unit = formState?.service_data?.unit
                    popupUpdates.gst_percent = formState?.service_data?.gst_percent
                    break;
            }
            return {
                ...prev,
                ...popupUpdates,
                concession_amt: formState?.service_data?.concession_amt,
                concession_percent: formState?.service_data?.concession_percent,
                concession_percent_w_r: formState?.service_data?.concession_percent_w_r,
                concession_comments: formState?.service_data?.concession_comments,
                doc_discount_amt: formState?.service_data?.doc_discount_amt,
                doc_discount_percent: formState?.service_data?.doc_discount_percent,
                doc_discount_percent_w_r: formState?.service_data?.doc_discount_percent_w_r,
                hos_discount_amt: formState?.service_data?.hos_discount_amt,
                hos_discount_percent: formState?.service_data?.hos_discount_percent,
                hos_discount_percent_w_r: formState?.service_data?.hos_discount_percent_w_r,
                doctor_percent: formState?.service_data?.doctor_percent,
                doctor_percent_w_r: formState?.service_data?.doctor_percent_w_r,
                hospital_percent: formState?.service_data?.hospital_percent,
                hospital_percent_w_r: formState?.service_data?.hospital_percent_w_r,
                unit_type: formState?.service_data?.unit_type,
                is_hospital: formState?.service_data?.is_hospital,
                service_head_id: formState?.service_data?.service_head_id,
                op_order_number: formState?.service_data?.op_order_number,
                old_time_taken: formState?.service_data?.old_time_taken
            }
        })
    }

    const onClickUnitHandler = useCallback((type) => {
        try {
            setformState((prev) => {
                const updatedServiceData = { ...prev.service_data };
                switch (type) {
                    case 'increase':
                        updatedServiceData.unit++;
                        break;
                    case 'decrease':
                        updatedServiceData.unit = Math.max(0, updatedServiceData.unit - 1); // Prevent negative units
                        break;
                }
                if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt) {
                    const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                    const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                    const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                    const conTlt = (+disDoc) + (+disHos)

                    updatedServiceData.total_amt = baseTotalAmt
                    updatedServiceData.old_doctor_amt = updatedOldDoc
                    updatedServiceData.old_hospital_amt = updatedOldHos
                    updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doc_discount_amt = disDoc
                    updatedServiceData.hos_discount_amt = disHos
                    updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                    updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                    updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                } else {
                    let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                    updatedServiceData.total_amt = total;
                    updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                }

                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [formState.service_data])

    const onUnitInputChange = useCallback((inputValue, previousUnit) => {
        try {
            const allowEmpty = inputValue === '';
            const parsed = parseInt(inputValue, 10);
            const isInvalidNumber = isNaN(parsed) && !allowEmpty;
            if (allowEmpty) {
                setformState((prev) => ({ ...prev, service_data: { ...prev.service_data, unit: '' } }));
                return;
            }
            if (isInvalidNumber) return;
            if (parsed > 9999) {
                const keepPrevious = previousUnit >= 1 && previousUnit <= 9999;
                const effectiveUnit = keepPrevious ? previousUnit : 9999;
                setformState((prev) => {
                    const updatedServiceData = { ...prev.service_data, unit: effectiveUnit };
                    if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt || updatedServiceData?.is_sharable) {
                        const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                        const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                        const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                        const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                        const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                        const conTlt = (+disDoc) + (+disHos)
                        updatedServiceData.total_amt = baseTotalAmt
                        updatedServiceData.old_doctor_amt = updatedOldDoc
                        updatedServiceData.old_hospital_amt = updatedOldHos
                        updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                        updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                        updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                        updatedServiceData.hospital_amt = updatedOldHos - disHos
                        updatedServiceData.doc_discount_amt = disDoc
                        updatedServiceData.hos_discount_amt = disHos
                        updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                        updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                        updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                    } else {
                        let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                        updatedServiceData.total_amt = total;
                        updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                    }
                    return { ...prev, service_data: updatedServiceData };
                });
                return;
            }
            const clampedUnit = Math.max(1, Math.floor(parsed));
            setformState((prev) => {
                const updatedServiceData = { ...prev.service_data, unit: clampedUnit };
                if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt || updatedServiceData?.is_sharable) {
                    const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                    const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                    const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                    const conTlt = (+disDoc) + (+disHos)
                    updatedServiceData.total_amt = baseTotalAmt
                    updatedServiceData.old_doctor_amt = updatedOldDoc
                    updatedServiceData.old_hospital_amt = updatedOldHos
                    updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doc_discount_amt = disDoc
                    updatedServiceData.hos_discount_amt = disHos
                    updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                    updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                    updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                } else {
                    let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                    updatedServiceData.total_amt = total;
                    updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                }
                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [])

    const withOutShareHandler = useCallback((e, key) => {
        try {
            const value = e.target.value
            setformState((prev) => {
                const update = { ...prev.service_data };
                switch (key) {
                    case 'rate_per_unit':
                        let Hours = (update?.hours === "" ? "00" : (update?.hours)?.toString()?.length < 2 ? ("0" + update?.hours) : update?.hours) + ":" + (update?.minutes === "" ? "00" : (update?.minutes)?.toString()?.length < 2 ? ("0" + update?.minutes) : update?.minutes) + ":" + "00"
                        let hourTotal = update.unit_type === 'Hrs' ? CalculateHourAmount(value, Hours, update.old_time_taken, update?.interval_time, update?.interval_amount) : 0
                        const newRatePerUnit = update.unit_type === 'Hrs' ? value : (value * update.unit)

                        update.rate_per_unit = value;
                        update.total_amt = update.unit_type === 'Hrs' ? hourTotal : (value * update.unit);
                        update.concession_amt = newRatePerUnit ? +CommonValidation.getDiscountAmountWithRound(update.concession_percent, newRatePerUnit) : ''
                        update.concession_percent = value ? update.concession_percent : ''
                        update.concession_percent_w_r = value ? update.concession_percent_w_r : ''
                        break;
                    case 'concession_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= update.total_amt || value === '') {
                            update.concession_amt = value
                            update.concession_percent = value ? +CommonValidation.getDiscountPercentage(value, update.total_amt) : ''
                            update.concession_percent_w_r = value ? +CommonValidation.getDiscountPercentageWithRound(value, update.total_amt) : ''
                        }
                        break;
                    case 'concession_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= 100 || value === '') {
                            update.concession_percent = value
                            update.concession_percent_w_r = value
                            update.concession_amt = +CommonValidation.getDiscountAmountWithRound(value, update.total_amt)
                        }
                        break;
                    default: break;
                }
                return { ...prev, service_data: update }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [formState?.service_data])

    const onAddHandler = () => {
        try {
            let { service_data, selected_bill_doc, selectedward } = formState || {};
            let { unit_type, total_amount = 0, gst_percent = 0, unit = 0, rate_per_unit = 0 } = service_data || {};
            let discountTotal = (+formState.service_data.total_amt) - (+formState.service_data.concession_amt)
            let incGst = loggedInUserInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, formState.service_data.gst_percent) : 0
            let tltGstdiff = loggedInUserInfo?.is_gst_enabled ? incGst - discountTotal : 0
            let sgstCgst = loggedInUserInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0
            let service_list = {
                ...service_data,
                total_with_discount: discountTotal,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal,
                sub_total_amount: formState.service_data.total_amt,
                concession_applicable: formState?.service_data?.edit_discount ? (formState?.service_data?.is_hospital ? formState?.service_data?.new_hospital_amt : discountTotal) : 0,
                module_type: formState.service_data.module_type,
                unit: formState.service_data?.unit,
                service_head_id: formState.service_data?.service_head_id,
                doctor_id: formState.selected_bill_doc?.doctor_id || formState.selected_bill_doc_id,
                doctor_name: formState.selected_bill_doc?.doctor_name || formState.selected_bill_doc,
                id: formState.service_data?.id ? formState?.service_data?.id : null,
                package_detail_id: formState.service_data?.package_detail_id ? formState?.service_data?.package_detail_id : null,
                package_name: formState?.service_data?.package_name ? formState?.service_data?.package_name : '',
            };

            let isDuplicate = false;

            setformState((prev) => {
                const orderList = [...prev.orderList];

                if (!prev.isEdit && orderList.find((item, index) => (index !== formState.selectedIndex && item?.service_details_id === service_list?.service_details_id && item?.doctor_id === service_list?.doctor_id))) {
                    isDuplicate = true;
                    errorMessage("Service already exists in the order.");
                    return prev;
                }
                if (prev.isEdit) {
                    orderList[prev.selectedIndex] = service_list;
                } else {
                    orderList.push(service_list);
                }
                return { ...prev, orderList, dupOrderList: JSON.stringify(orderList) };
            });
            if (!isDuplicate) {
                setTimeout(() => onClearServiceData(), 50);
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClearServiceData = (is_from) => {
        try {
            setformState((prev) => ({
                ...prev,
                selected_service: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null
                },
                isEdit: false,
                selectedIndex: null,
                orderList: is_from === 'clear' ? [] : prev.orderList
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderEditFeilds = () => {
        return (
            <Box component={'div'} mt={'0.5rem'} display={'flex'} justifyContent={'space-around'} alignItems={'center'} sx={{ width: "100%" }}>
                <Autocomplete
                    size='small'
                    sx={{ width: '15dvw' }}
                    options={formState.billDocSugg}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                    value={formState.selected_bill_doc}
                    disabled
                    onChange={(e, newValue) => {
                        setformState((prev) => ({
                            ...prev, selected_bill_doc: newValue, selected_service: null,
                            service_data: {
                                ...prev.service_data,
                                edit_unit: '',
                                rate_per_unit: '',
                                total_amount: '',
                                unit: 1, unit_type: 'Nos',
                            },
                        }))
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        disabled
                        label='Bill Doctor'
                        InputProps={{
                            ...params.InputProps, emed_tid: 'Bl_doc',
                        }}
                    />}
                />

                {props?.FromIp && <Autocomplete
                    size='small'
                    options={formState?.wardList || []}
                    getOptionLabel={(option) => option?.ward_name || ''}
                    sx={{ width: '12dvw' }}
                    value={formState?.selectedward}
                    disabled
                    onChange={(event, newValue) => {
                        setformState((prev) => ({
                            ...prev,
                            selectedward: newValue, selected_service: null,
                            service_data: {
                                ...prev.service_data,
                                edit_unit: '',
                                rate_per_unit: '',
                                total_amount: '',
                                unit: 1, unit_type: 'Nos',
                            },
                        }));
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            disabled
                            label='Select Ward'
                        />
                    )}
                />}

                <Autocomplete
                    size='small'
                    sx={{ width: AmountViewAccess ? '25dvw' : '60dvw' }}
                    options={[formState.selected_service]}
                    disabled={!formState.selected_bill_doc || formState?.fromOrderSummary || (!formState?.selectedward && formState?.PatientData?.id) || formState?.PatientData?.is_final_bill_initiated}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : `${(option?.service_head_name) && option?.service_head_code ? `${option?.service_head ?? option?.service_head_name} (${option?.service_head_code})` : option?.service_head ?? option?.service_head_name} - ${option?.service_name && option?.service_code ? `${option?.service_name} (${option?.service_code})` : option?.service_name}`}
                    value={formState.selected_service}
                    renderInput={(params) => <TextField
                        {...params}
                        label='Search Service'
                        InputProps={{
                            ...params.InputProps, emed_tid: 'ser_sear',
                        }}
                    />}

                />

                {formState?.service_data?.unit_type === 'Hrs' ?
                    <Box component={'div'}
                        border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                        display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                        <Button
                            disabled={!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                            sx={{ textTransform: 'capitalize' }}
                            endIcon={<AccessTimeIcon />}
                            onClick={() => onOpenPopupHandler('time')}
                        >{`${formState?.service_data?.unit?.length > 5 ? formState?.service_data.unit?.slice(0, 5) : formState?.service_data?.unit}`}</Button>
                    </Box> :
                    <Box component={'div'} border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                        display={'flex'} alignItems={'stretch'} justifyContent={'space-between'} width={'9dvw'}>
                        <IconButton
                            sx={{ height: 'auto', width: '2.5dvw', borderRadius: '5px 0 0 5px' }}
                            disabled={(formState?.service_data?.unit === '' || +formState?.service_data?.unit <= 1) || !formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                            onClick={() => onClickUnitHandler('decrease')}
                        ><RemoveIcon color={((formState?.service_data?.unit === '' || +formState?.service_data?.unit <= 1) || !formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
                        <TextField
                            type="number"
                            size="small"
                            variant="standard"
                            value={formState?.service_data?.unit === '' || formState?.service_data?.unit === undefined ? '' : formState?.service_data?.unit}
                            onChange={(e) => onUnitInputChange(e.target.value, formState?.service_data?.unit)}
                            onBlur={(e) => {
                                const v = e.target.value;
                                if (v === '' || isNaN(parseInt(v, 10))) onUnitInputChange('1', formState?.service_data?.unit);
                            }}
                            disabled={!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                            inputProps={{ min: 1, max: 9999, inputMode: 'numeric' }}
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                flex: 1,
                                minWidth: 0,
                                '& .MuiInputBase-root': { height: '100%', '& input': { textAlign: 'center', fontSize: COMMON_STYLES.FONT_SIZE_L, fontWeight: COMMON_STYLES.FONT_WEIGHT } },
                                '& input[type=number]': { MozAppearance: 'textfield' },
                                '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 }
                            }}
                        />
                        <IconButton
                            disabled={!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                            sx={{ height: 'auto', width: '2.5dvw', borderRadius: '0 5px 5px 0' }}
                            onClick={() => onClickUnitHandler('increase')}
                        ><AddIcon color={(!formState?.service_data?.edit_unit || formState?.fromOrderSummary || formState?.PatientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)) ? 'disabled' : 'primary' } /></IconButton>
                    </Box>}

                {AmountEditAccess ?
                    (!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                        <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                            disabled={!formState?.service_data?.edit_amount}
                            endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.rate_per_unit)})`}
                            onClick={() => onOpenPopupHandler('rate')}
                        >Rate/Unit</Button> :
                        <TextField
                            autoComplete='off'
                            size='small'
                            InputProps={{ emed_tid: 'rte_unit', readOnly: !formState?.service_data?.edit_amount }}
                            sx={{ width: '7dvw' }}
                            label='Rate/Unit'
                            value={formState?.service_data?.rate_per_unit}
                            onChange={(e) => { withOutShareHandler(e, 'rate_per_unit') }}
                        />
                    : null}

                {AmountViewAccess && ConcessionAccess ?
                    <Box component={'div'} display={'flex'}>
                        {(!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                            <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                disabled={!formState?.service_data?.edit_discount}
                                endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.concession_amt)})`}
                                onClick={() => onOpenPopupHandler('concession')}
                            >Concession</Button>
                            :
                            <><TextField
                                disabled={!formState?.service_data?.edit_discount}
                                autoComplete='off'
                                size='small'
                                InputProps={{ emed_tid: 'con_amt' }}
                                sx={{ width: '7dvw' }}
                                label={`Concession (${CurrencySymbol})`}
                                value={+formState?.service_data?.concession_amt ? formState?.service_data?.concession_amt : ""}
                                onChange={(e) => { withOutShareHandler(e, 'concession_discount_amt') }}
                            />
                                <TextField
                                    disabled={!formState?.service_data?.edit_discount}
                                    autoComplete='off'
                                    size='small'
                                    InputProps={{ emed_tid: 'con_per' }}
                                    sx={{ width: '7dvw' }}
                                    label={`Concession (%)`}
                                    value={+formState?.service_data?.concession_percent_w_r ? formState?.service_data?.concession_percent_w_r : ""}
                                    onChange={(e) => { withOutShareHandler(e, 'concession_discount_percent') }}
                                /></>}
                    </Box>
                    : null}


                {AmountViewAccess ? <Box component={'div'}>
                    <TextField
                        size='small'
                        sx={{ width: '9dvw' }}
                        value={formState?.service_data?.total_amt ? CommonValidation.formatAmount((+formState?.service_data?.total_amt) - (+formState?.service_data?.concession_amt)) : ''}
                        InputProps={{ emed_tid: 'tlt', readOnly: true }}
                        label='Total'
                    />
                </Box> : null}

                <Tooltip title={'Update Order'} placement='top' arrow>
                    <IconButton
                        sx={{ height: '2dvw', width: '2.5dvw' }}
                        onClick={() => {
                            setformState((prev) => ({
                                ...prev,
                                // selectedIndex: index,
                                // selectedData: item,
                                openDialog: true
                            }));
                        }}
                    ><CheckCircleOutlineIcon color='primary' sx={{ height: '2dvw', width: '1.7dvw' }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={'Clear Edit'} placement='top' arrow>
                    <IconButton
                        sx={{ height: '2dvw', width: '2.5dvw' }}
                        onClick={() => {
                            clearSelection()
                        }}
                    ><HighlightOffIcon sx={{ height: '2dvw', width: '1.7dvw' }} color={'error'} />
                    </IconButton>
                </Tooltip>
            </Box>
        )
    }

    const clearSelection = () => {
        setformState((prev) => ({
            ...prev,
            selected_service: null,
            service_data: {
                rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                concession_comments: '', service_details_id: '', doctor_id: '',
                review_days: '', review_count: '', charge_id: '',
                gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                taxable_amount: '', sub_total_amount: '', round_off: '',
                received_amount: '', net_amount: '', concession_percent_w_r: '',
                doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                doctor_percent_w_r: '', hospital_percent_w_r: '',
                module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                service_head_id: null, doctor_id: '', op_order_number: '',
                id: null
            },
            isEdit: false,
            selectedIndex: null,
            selectedIndex: '',
            openDialog: false,
        }))
    }

    const closeMenu = () => {
        setState((prev) => ({
            ...prev,
            menuAnchorEl: null,
            menuRowId: null,
            isIssueDrug: false,
        }))
    }

    const printIssueDrug = (data) => {
        try {
            setState((prev)=> ({...prev, isIssueDrug: true}))
            RestAPIService.PrintPDF(`${Serviceurls.NEW_BILLING_ISSUE_DRUG_PRINT}?module_type=IP&id=${data?.id}`)
                .then((response) => {
                    if (response) {
                        setState((prev)=> ({...prev, isIssueDrug: false}))
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    setState((prev)=> ({...prev, isIssueDrug: false}))
                    errorMessage(error.response?.data?.message)
                })
        } catch (e) {
            setState((prev)=> ({...prev, isIssueDrug: false}))
            errorMessage(e.message)
        }
    }

    const MenuItemTbl = (data, index) => {
        const multi_option = [{ value: "IssueDrug", label: "Issued Drugs" }]
        return (
            <div key={`menu-${data?.id}`}>
                <Tooltip title={"More"} placement='top' arrow>
                    <IconButton
                        onClick={(e) => {
                            setState((prev) => ({
                                ...prev,
                                menuAnchorEl: e.currentTarget,
                                menuRowId: data.id,
                            }));
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(state.menuAnchorEl && state.menuRowId === data.id) ?
                    <Menu
                        anchorEl={state.menuAnchorEl}
                        open={state.menuRowId === data.id}
                        onClose={closeMenu}>
                        {multi_option?.map((option) => (
                            <MenuItem key={option.value}
                                disabled = {(option?.value === "IssueDrug" && state.isIssueDrug) ? true : false}
                                onClick={() => {
                                    if (option?.value === "IssueDrug") {
                                        printIssueDrug(data)
                                    }
                                }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        )
    }

    const getServiceHeadOptions = () => {
        const list = formState?.ListData || [];
        return [...new Set(list.map((i) => i?.service_head_name).filter(Boolean))];
    };

    const getServiceNameOptions = () => {
        const list = formState?.ListData || [];
        const scoped = filters?.service_head ? list.filter((i) => i?.service_head_name === filters.service_head) : list;
        return [...new Set(scoped.map((i) => i?.service_name).filter(Boolean))];
    };

    const getFilteredListData = () => {
        const list = formState?.ListData || [];
        return list.filter((item) => {
            if (filters?.service_head && item?.service_head_name !== filters.service_head) return false;
            if (filters?.service_name && item?.service_name !== filters.service_name) return false;
            return true;
        });
    };

    const renderTableFunction = () => {
        try {
            const userAccess = getCachevalue("PatientData")
                ? CheckAccessFunc("front_office", "Home", "Order", "Order List", "SubTab")
                : CheckAccessFunc("front_office", "In Patients", "Order", "Order List", "SubTab");
            const listDataToRender = getFilteredListData();
            return (
                <TableContainer sx={{ height: formState?.isEdit ? '50dvh' : '54dvh', overflow: 'auto', border: '1px solid lightgray' }}>
                    <Table stickyHeader>
                        <TableHead size="small" sx={{ "& .MuiTableCell-root": { padding: "0.25rem" } }}>
                            <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                {view === 'list' ? (
                                    <>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>S.No</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Service ID</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Created Details</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Doctor Name</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Service Description</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Module</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Unit</TableCell>
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Rate Per Unit</TableCell> : null}
                                        {(formState?.is_gst_enabled && AmountViewAccess) ? <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>GST</TableCell> : null}
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}> Total Amount</TableCell> : null}
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Status</TableCell>
                                        {userAccess?.editAccess && <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Action</TableCell>}
                                    </>
                                ) : (
                                    <>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>S.No</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Order No</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Created Date & Time</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>No Of Services</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Created By</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Action</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ "& .MuiTableCell-root": { padding: "0px" } }}>
                            {view === 'list' ? (
                                listDataToRender?.map((item, index) => {
                                    const tempTotal = item?.unit_type !== 'Hrs' ? (item?.tempUnit * item?.tempRate) + ((item?.tempUnit * item?.tempRate * (item?.gst_percent || 0)) / 100) : null;
                                    const Package_Name = item?.packagename ? `${item?.packagename}` : null
                                    return (
                                        <TableRow key={index}>
                                            <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.65vw" }}>{index + 1}</TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>
                                                {item?.order_item_number ? (
                                                    // sliced based on the first slash
                                                    <Tooltip title={item.order_item_number} arrow>
                                                        <Typography>
                                                            {item.order_item_number.includes('/')
                                                                ? `...${item.order_item_number.slice(item.order_item_number.indexOf('/'))}`
                                                                : item.order_item_number}
                                                        </Typography>
                                                    </Tooltip>
                                                ) : (
                                                    '-'
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>
                                                <Box component={'div'}>{(item?.created_by || item?.created_date) ?
                                                    <Tooltip placement='top' title={item?.created_by || formatDateAndTimeMeth2(item?.created_date)} arrow>
                                                        <Box>
                                                            <Typography fontWeight={600} fontSize={'0.8vw'}>{item?.created_by || "-"}</Typography>
                                                            <Box display={'flex'}>
                                                                <Typography fontSize={'0.8vw'}>{item?.created_date ? formatDateAndTimeMeth2(item?.created_date) : '-'}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </Tooltip> : "-"}
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>{item.bill_doctor_name || '-'}</TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>
                                                <Box component={'div'}>{item?.service_head_name && item?.service_name ?
                                                    <Box>
                                                        <Box sx={{ display : 'flex'}}>
                                                            {/* tool tip funtionality */}
                                                            {item?.service_head_name?.length > 25 ? (
                                                                <Tooltip title={item?.service_head_name} arrow>
                                                                    <Typography fontWeight={600} fontSize={'0.8vw'}>
                                                                        {`${item?.service_head_name.slice(0, 20)}...`}
                                                                    </Typography>
                                                                </Tooltip>
                                                            ) : (
                                                                <Typography fontWeight={600} fontSize={'0.8vw'}>
                                                                    {item?.service_head_name}
                                                                </Typography>
                                                            )}
                                                            {Package_Name ? Package_Name?.length > 25 ? (
                                                                <Tooltip title={Package_Name} arrow>
                                                                    <Typography marginLeft={"0.5vw"} fontWeight={600} fontSize={'0.8vw'}>
                                                                        {`( ${Package_Name.slice(0, 20)}... )`}
                                                                    </Typography>
                                                                </Tooltip>
                                                            ) : (
                                                                <Typography marginLeft={"0.5vw"} fontWeight={600} fontSize={'0.8vw'}>
                                                                    {`( ${Package_Name} )`}
                                                                </Typography>
                                                            ) : null}
                                                        </Box>
                                                        <Box display={'flex'}>
                                                            {item?.service_name?.length > 15 ? (
                                                                <Tooltip
                                                                    title={`${(item?.service_code) ? item?.service_code : (item?.service_head_code) ? item?.service_head_code : '-'} | ${item?.service_name}`}
                                                                    arrow
                                                                >
                                                                    <Typography fontSize={'0.8vw'}>
                                                                        {`${(item?.service_code) ? item?.service_code : (item?.service_head_code) ? item?.service_head_code : '-'} | ${item?.service_name.slice(0, 15)}...`}
                                                                    </Typography>
                                                                </Tooltip>
                                                            ) : (
                                                                <Typography fontSize={'0.8vw'}>
                                                                    {`${(item?.service_code) ? item?.service_code : (item?.service_head_code) ? item?.service_head_code : '-'} | ${item?.service_name}`}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                    : "-"}
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>{(item?.module_type === 'IP_OP' ? 'IP & OP' : item?.module_type) || '-'}</TableCell>
                                            <TableCell sx={{ fontSize: '0.9rem' }}>
                                                {(item?.isEditing && item?.unit_type !== 'Hrs') ? (
                                                    <Box component="div" border="1px solid lightgray" borderRadius="5px" height="4dvh" display="flex" alignItems="center" justifyContent="space-evenly" width="6dvw">
                                                        <IconButton
                                                            sx={{ height: '2.5dvh', width: '2dvw' }}
                                                            disabled={+item.tempUnit === 1}
                                                            onClick={() => {
                                                                setformState((prev) => {
                                                                    const updatedOrderList = [...prev.ListData];
                                                                    const currentRow = { ...updatedOrderList[index] };

                                                                    currentRow.tempUnit = Math.max(1, +currentRow.tempUnit - 1);
                                                                    const baseTotalAmt = currentRow.tempUnit * currentRow.rate_per_unit;
                                                                    currentRow.total_amount = baseTotalAmt;

                                                                    if ((currentRow.doctor_amt || currentRow.hospital_amt) &&
                                                                        (currentRow.doctor_share_percent || currentRow.hospital_share_percent)) {

                                                                        if (currentRow.doctor_share_percent) {
                                                                            currentRow.doctor_amt = (baseTotalAmt * currentRow.doctor_share_percent) / 100;
                                                                        }

                                                                        if (currentRow.hospital_share_percent) {
                                                                            currentRow.hospital_amt = (baseTotalAmt * currentRow.hospital_share_percent) / 100;
                                                                        }
                                                                    }

                                                                    updatedOrderList[index] = currentRow;
                                                                    return { ...prev, ListData: updatedOrderList };
                                                                });
                                                            }}
                                                        >
                                                            <RemoveIcon color={+item.tempUnit === 1 ? 'disabled' : 'primary'} /></IconButton>
                                                        <Typography>{item.tempUnit}</Typography>
                                                        <IconButton
                                                            sx={{ height: '2.5dvh', width: '2dvw' }}
                                                            onClick={() => {
                                                                setformState((prev) => {
                                                                    const updatedOrderList = [...prev.ListData];
                                                                    const currentRow = { ...updatedOrderList[index] };

                                                                    currentRow.tempUnit = +currentRow.tempUnit + 1;
                                                                    const baseTotalAmt = currentRow.tempUnit * currentRow.rate_per_unit;
                                                                    currentRow.total_amount = baseTotalAmt;
                                                                    currentRow.sub_total_amount = baseTotalAmt;

                                                                    if ((currentRow.doctor_amt || currentRow.hospital_amt) &&
                                                                        (currentRow.doctor_share_percent || currentRow.hospital_share_percent)) {

                                                                        if (currentRow.doctor_share_percent) {
                                                                            currentRow.doctor_amt = (baseTotalAmt * currentRow.doctor_share_percent) / 100;
                                                                        }

                                                                        if (currentRow.hospital_share_percent) {
                                                                            currentRow.hospital_amt = (baseTotalAmt * currentRow.hospital_share_percent) / 100;
                                                                        }
                                                                    }

                                                                    updatedOrderList[index] = currentRow;
                                                                    return { ...prev, ListData: updatedOrderList };
                                                                });
                                                            }}
                                                        >
                                                            <AddIcon color="primary" /></IconButton>
                                                    </Box>
                                                ) : (item?.unit_type === 'Hrs' && item?.isEditing) ? (
                                                    <Box component={'div'} border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                                                        display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                                                        <Button
                                                            sx={{ textTransform: 'capitalize' }}
                                                            endIcon={<AccessTimeIcon />}
                                                            onClick={() => InlineTimePopup(item, index)}
                                                        >{`${item?.unit?.length > 5 ? item?.unit?.slice(0, 5) : item?.unit}`}</Button>
                                                    </Box>
                                                ) : <div style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{item?.unit_type === 'Hrs' ? ((item?.unit?.split(':').slice(0, 2).join(':')) || '-') : (item?.unit || '-')}</div>}
                                            </TableCell>
                                            {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>{item?.rate_per_unit || 0}</TableCell> : null}
                                            {(formState?.is_gst_enabled && AmountViewAccess) ? <TableCell sx={{ fontSize: '0.9rem' }}>{item.gst_percent || 0}</TableCell> : null}
                                            {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>
                                                {item?.isEditing && item?.unit_type !== 'Hrs' ? CommonValidation.formatAmount(tempTotal) :
                                                    (item?.total_amount && item?.service_head_name === "Room Charges" && RoomChargeGST?.is_room_charge_gst_applicable && item?.gst_percent && item?.total_amount > +RoomChargeGST?.room_charge_gst_limit) ?
                                                        <div>
                                                            <div style={{ fontSize: "0.9vw" }}>{CommonValidation.formatAmount(item?.total_amount)}</div>
                                                            <div style={{ fontSize: "0.8vw" }}>{(`(Include ${item?.gst_percent}% gst)`)}</div>
                                                        </div> :
                                                        item?.is_advance_adjusted ?
                                                            <div>
                                                                <div style={{ fontSize: "0.9vw" }}>{CommonValidation.formatAmount(item?.total_amount)}</div>
                                                                <div style={{ fontSize: "0.8vw", color:'green' }}>{(`Advance Adjusted`)}</div>
                                                            </div> :
                                                            item?.total_amount ? CommonValidation.formatAmount(item?.total_amount) : '0'}
                                            </TableCell> : null}
                                            <TableCell sx={{ fontSize: '0.9rem' }}>{item.order_line_status || '-'}</TableCell>
                                            {userAccess?.editAccess && <TableCell sx={{ display: "flex", flexDirection: "row" }}>
                                                <Box sx={{ display: "flex", height: '5dvh', visibility : formState?.isEdit ? 'hidden' : 'visible' }}>
                                                    <div style={{ marginTop: '0.4vw' }}>
                                                        <LineItemRemarksButton
                                                            enabled={isLineItemRemarksEnabled()}
                                                            readOnly={orderLineRemarksReadOnly(item)}
                                                            value={item.remarks || item.line_item_remarks || ''}
                                                            onSave={(text) => {
                                                                const v = clampLineItemRemarks(text)
                                                                handleUpdateOrder({ ...item, line_item_remarks: v, remarks: v })
                                                            }}
                                                        />
                                                    </div>
                                                    <IconButton
                                                        sx={{ visibility: (item?.package_id || item?.assorted_id || item?.package_detail_id || item?.assorted_package_id || item?.is_advance_adjusted) ? "hidden" : "visible" }}
                                                        onClick={() => {
                                                            let total_with_discount = item?.total_amount ? item?.total_amount : item?.service_charge ? item?.service_charge : item?.total_amount
                                                            let totalAmt = item?.sub_total_amount ? item?.sub_total_amount : item?.service_charge ? item?.service_charge : item?.total_amount
                                                            const concession_amt = item?.discount_amount ? item?.discount_amount : 0
                                                            const concession_percent = item?.discount_percentage ? item?.discount_percentage : 0

                                                        const oldDocAmt = item?.old_doctor_fee ? item?.old_doctor_fee : item?.new_doctor_fee ? item?.new_doctor_fee : item?.doctor_share_amount ? item?.doctor_share_amount : ''
                                                        const oldHosAmt = item?.old_hospital_fee ? item?.old_hospital_fee : item?.new_hospital_fee ? item?.new_hospital_fee : item?.hospital_share_amount ? item?.hospital_share_amount : ''
                                                        const newDocAmt = item?.new_doctor_fee ? item?.new_doctor_fee : item?.doctor_share_amount ? item?.doctor_share_amount : ''
                                                        const newHosAmt = item?.new_hospital_fee ? item?.new_hospital_fee : item?.hospital_share_amount ? item?.hospital_share_amount : ''
                                                        const docAmt = item?.new_doctor_fee ? item?.new_doctor_fee : item?.doctor_share_amount ? item?.doctor_share_amount : ''
                                                        const hosAmt = item?.new_hospital_fee ? item?.new_hospital_fee : item?.hospital_share_amount ? item?.hospital_share_amount : ''
                                                        const docPer = item?.doctor_share_percent ? item?.doctor_share_percent : ''
                                                        const hosPer = item?.hospital_share_percent ? item?.hospital_share_percent : ''

                                                        const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                                                        const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                                                        const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                                                        const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

                                                        const sub_total_amount = item?.sub_total_amount ? item?.sub_total_amount : item?.service_charge ? item?.service_charge : 0
                                                        const old_time_taken = item?.service_old_unit_count ? item?.service_old_unit_count : item?.service_unit ? item?.service_unit : null

                                                        let FinalItem = {
                                                            ...item,
                                                            total_with_discount: total_with_discount,
                                                            total_amount: total_with_discount,
                                                            total_amt: totalAmt ?? 0,
                                                            concession_amt: concession_amt,
                                                            concession_percent: concession_percent,
                                                            concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                                                            doctor_amt: docAmt,
                                                            doctor_percent: docPer,
                                                            old_doctor_amt: oldDocAmt,
                                                            new_doctor_amt: newDocAmt,
                                                            hospital_amt: hosAmt,
                                                            hospital_percent: hosPer,
                                                            old_hospital_amt: oldHosAmt,
                                                            new_hospital_amt: newHosAmt,
                                                            doc_discount_amt: disDocAmt,
                                                            doc_discount_percent: disDocPer || '',
                                                            doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                                                            hos_discount_amt: disHosAmt,
                                                            hos_discount_percent: disHosPer || '',
                                                            hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                                                            doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                                                            hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                                                            sub_total_amount: sub_total_amount,
                                                            hours: item.unit_type === 'Hrs' ? item.unit?.split(":")[0] : '',
                                                            minutes: item.unit_type === 'Hrs' ? item.unit?.split(":")[1] : '',
                                                            interval_time: item.interval_time,
                                                            interval_amount: item.interval_amount,
                                                            old_time_taken: old_time_taken,
                                                            start_date: new Date(),
                                                            end_date: null,
                                                            membership_discount_percentage: item?.is_membership_discount_applied ?? 0,
                                                            edit_discount: item?.is_membership_discount_applied ? false : item?.edit_discount
                                                        }
                                                        setformState((prev) => ({
                                                            ...prev,
                                                            service_data: FinalItem,
                                                            selected_service: FinalItem,
                                                            isEdit: true,
                                                            selectedIndex: index,
                                                            selectedward : prev?.wardList?.find(ward => ward?.id === item?.ward_id),
                                                            selected_bill_doc: prev.billDocSugg?.find(doc => doc.doctor_id === item?.bill_doctor_id) || null,
                                                        }));
                                                    }} size="small" disabled={EditDisable(item) || item?.package_type === 'Assorted' || item?.package_type === 'Package' || item?.service_head_name === "Room Charges"} >
                                                        <img style={{ width: "1.2vw", height: "1.2vw" }} src={EditDisable(item) || item?.service_head_name === "Room Charges" ? ImagePaths.NewBillEditoff.default : ImagePaths.UserEditOn.default} alt={"edit"} />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => {
                                                            setformState((prev) => ({
                                                                ...prev,
                                                                openDeletePopup: true,
                                                                deleted_service: item?.id,
                                                                selected_cancel_service : item,
                                                                deletedType: 'list'
                                                            }))
                                                        }}
                                                        size="small" disabled={DeleteDisabled(item) || item?.service_head_name === "Room Charges"} ><img style={{ width: "1.2vw", height: "1.2vw" }}
                                                            src={DeleteDisabled(item) || item?.service_head_name === "Room Charges" ? ImagePaths.NewBillCloseoff.default : ImagePaths.NewBillClose.default} alt={"delete"} />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>}
                                        </TableRow>
                                    )
                                })
                            ) : (
                                formState?.SummaryData?.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.65vw" }}>{index + 1}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{item.order_number || '-'}</TableCell>
                                        <TableCell >
                                            <Box component={'div'} fontSize={'0.9rem'}>{item?.created_date ? formatDateAndTimeMeth2(item?.created_date) : "-"}</Box>
                                        </TableCell>
                                        <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.65vw" }}>{`${item?.accepted_count} / ${item?.total_count}`}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{item.created_by || '-'}</TableCell>
                                        <TableCell sx={{ display: "flex", flexDirection: "row" }}>
                                            {userAccess?.editAccess && <IconButton onClick={() => {
                                                setCachevalue(JSON.stringify(item?.id), "OrderID")
                                                history.push({ pathname: formState.PatientData?.appointment_id ? "/OPHome/PatientDetails/CreateOrder" : '/IPHome/PatientDetails/CreateOrder', state: { Reset: true } })
                                            }}
                                                size="small" disabled={(item?.has_includes_room_charge) || (item?.accepted_count > 0 && ((item?.is_block_edit && formState?.PatientData?.id) || (formState?.PatientData?.appointment_id)))} ><img style={{ width: "1.2vw", height: "1.2vw" }} src={item?.has_includes_room_charge ? ImagePaths.NewBillEditoff.default : item?.accepted_count <= 0 || (!item?.is_block_edit && formState?.PatientData?.id) ? ImagePaths.UserEditOn.default : ImagePaths.NewBillEditoff.default} alt={"edit"} />
                                            </IconButton>}
                                            <IconButton onClick={() => { orderListPrint("summary", item?.id) }} size="small" ><img style={{ width: "1.2vw", height: "1.2vw" }} src={ImagePaths.printLayout.default} alt={"print"} /></IconButton>
                                            {userAccess?.editAccess && <IconButton onClick={() => {
                                                setformState((prev) => ({
                                                    ...prev,
                                                    openDeletePopup: true,
                                                    deleted_service: item?.id,
                                                    selected_cancel_service : item,
                                                    deletedType: 'summary'
                                                }))
                                            }}
                                                size="small" disabled={(item?.has_includes_room_charge) || (item?.accepted_count > 0 && ((item?.is_processed && formState?.PatientData?.id) || (formState?.PatientData?.appointment_id)))}><img style={{ width: "1.2vw", height: "1.2vw" }} src={item?.has_includes_room_charge ? ImagePaths.NewBillCloseoff.default : item?.accepted_count <= 0 || (!item?.is_processed && formState?.PatientData?.id) ? ImagePaths.NewBillClose.default : ImagePaths.NewBillCloseoff.default} alt={"edit"} />
                                            </IconButton>}
                                            {  props?.FromIp && item?.is_issued_drug && loggedInUserInfo?.show_assorted_inhouse_drug === true && MenuItemTbl(item)}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const orderListPrint = (type, order_id = null) => {
        try {
            let url = "";
            const { appointment_id, id } = formState?.PatientData || {};
            const moduleType = filters?.module === "All" ? "" : filters?.module;
            const orderStatus = filters?.status;
            const exportType = "pdf";
            const clinicId = JSON.parse(localGetItem("SelectedDoctorClinicId")) ? `&clinic_id=${JSON.parse(localGetItem("SelectedDoctorClinicId"))}` : "";
            const serviceHeadParam = filters?.service_head ? `&service_head_name=${encodeURIComponent(filters.service_head)}` : "";
            const serviceNameParam = filters?.service_name ? `&service_name=${encodeURIComponent(filters.service_name)}` : "";
            if (type === "list") {
                if (appointment_id) {
                    url = `${Serviceurls.BILLING_ORDER_LIST}?appointment_id=${appointment_id}&get_type=list&order_status=${orderStatus}&module_type=${moduleType}${serviceHeadParam}${serviceNameParam}&export_type=${exportType}`;
                } else if (id) {
                    url = `${Serviceurls.BILLING_ORDER_LIST_IP}?ip_admission_id=${id}&get_type=list&order_status=${orderStatus}&module_type=${moduleType}${serviceHeadParam}${serviceNameParam}&export_type=${exportType}`;
                }
            } else if (type === "summary") {
                if (appointment_id) {
                    url = `${Serviceurls.NEW_BILLING_OP_ORDER_LIST}?order_id=${order_id}&appointment_id=${appointment_id}&export_type=${exportType}`;
                } else if (id) {
                    url = `${Serviceurls.NEW_BILLING_IP_ORDER_GET}?order_id=${order_id}&ip_admission_id=${id}&export_type=${exportType}`;
                }
            }
            if (clinicId) {
                url = `${url}${clinicId}`;
            }
            RestAPIService.getAll(url)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage?.(error?.response?.data?.message || "Unknown Error");
                    } else {
                        errorMessage?.(error?.message || "An error occurred");
                    }
                });
        } catch (error) {
            errorMessage(error?.message)
        }

    }

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "74vh" }}>
            <Box component={"div"} marginLeft={"0.5vw"} className="eMed_patient_header">
                <Box display={"flex"} alignItems="center">
                    <CommonPatientSection PatientData={formState?.PatientData} />
                </Box>
            </Box>
            <Box sx={{ backgroundColor: "white", margin: "1vw 0.5vw", padding: "0.5vw", height: '65.5dvh' }}>
                <Box display='flex' flexDirection='row' alignItems='center' justifyContent={'space-between'} mb={"0.25vw"}>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <div onClick={() => setView('list')} style={{ border: "1px solid gray", borderRight: 'none', width: "6.5vw", height: "2.2vw", cursor: "pointer", textAlign: "center", backgroundColor: view === 'list' ? Colors.themeBackgroud : null, paddingTop: "0.3vw", color: view === 'list' ? 'white' : null, fontSize: "0.9vw" }}>List</div>
                        <div onClick={() => {
                            setView('summary')
                            clearSelection()
                        }} style={{ border: "1px solid gray", borderLeft: "none", width: "6.5vw", height: "2.2vw", cursor: "pointer", textAlign: "center", backgroundColor: view === 'summary' ? Colors.themeBackgroud : null, paddingTop: "0.3vw", color: view === 'summary' ? 'white' : null, fontSize: "0.9vw" }}>Summary</div>
                    </Box>
                    {view === 'list' ? <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }} gap={0.5}>
                        <Button className='Common_Btn_Min_Width' onClick={() => { }}>
                            <Tooltip placement='top' title='Print'>
                                <Box component={'img'} onClick={() => { orderListPrint("list") }} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
                            </Tooltip>
                        </Button>

                        <FormControl sx={{ width: '15dvw', mr: "1vw" }} size='small'>
                            <InputLabel>Module</InputLabel>
                            <Select
                                label='Module'
                                value={filters.module}
                                onChange={(e) => {
                                    setFilters((prev) => ({ ...prev, module: e.target.value, service_head: null, service_name: null }))
                                }}
                            >
                                <MenuItem value={'All'}>All</MenuItem>
                                {formState?.PatientData?.appointment_id ? <MenuItem value={'OP'}>Out Patient</MenuItem> : null}
                                {formState?.PatientData?.id ? <MenuItem value={'IP'}>In Patient</MenuItem> : null}
                                {formState?.PatientData?.id ? <MenuItem value={'IP_OP'}>In Patient & Out Patient</MenuItem> : null}
                                <MenuItem value={'LAB'}>Laboratory</MenuItem>
                                <MenuItem value={'RADIOLOGY'}>Radiology</MenuItem>
                                {localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")).map((investigation, index) => (
                                    <MenuItem key={index} value={investigation}>{investigation}</MenuItem>
                                )) : null}
                            </Select>
                        </FormControl>

                        <Autocomplete
                            size='small'
                            sx={{ width: '15dvw', mr: "1vw" }}
                            options={getServiceHeadOptions()}
                            value={filters.service_head}
                            onChange={(event, newValue) => {
                                setFilters((prev) => ({ ...prev, service_head: newValue, service_name: null }))
                            }}
                            renderInput={(params) => <TextField {...params} label='Service Head' />}
                        />

                        <Autocomplete
                            size='small'
                            sx={{ width: '15dvw', mr: "1vw" }}
                            options={getServiceNameOptions()}
                            value={filters.service_name}
                            onChange={(event, newValue) => {
                                setFilters((prev) => ({ ...prev, service_name: newValue }))
                            }}
                            renderInput={(params) => <TextField {...params} label='Service Name' />}
                        />

                        <FormControl sx={{ width: '15dvw', mr: "1vw" }} size='small'>
                            <InputLabel>Status</InputLabel>
                            <Select
                                label='Patient Type'
                                value={filters.status}
                                onChange={(e) => {
                                    setFilters((prev) => ({ ...prev, status: e.target.value }))
                                }}
                            >
                                <MenuItem value={'Pending,Billed,Accepted'}>All</MenuItem>
                                <MenuItem value={'Pending'}>Pending</MenuItem>
                                <MenuItem value={'Billed'}>Billed</MenuItem>
                                <MenuItem value={'Accepted'}>Accepted</MenuItem>
                                {/* <MenuItem value={'Draft'}>Draft</MenuItem> */}
                            </Select>
                        </FormControl>
                    </Box> : null}
                </Box>
                <Box>{renderTableFunction()}</Box>
                <Box>{(formState?.isEdit && view === 'list') ? renderEditFeilds() : null}</Box>
            </Box>
            {TimePopup()}
            {renderDeletePopup()}
            {confirmationPopup()}
            <Loader loaderOpen={isLoader} />
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
        </Box>
    );
};

export default OrderListScreen;